function DazAggregatorXC(address, chainId, aggregatorContract) {
    this.crossChain = true;
    this.chainId = chainId;
    this.address = address;
    this.aggData = false;
}

DazAggregatorXC.prototype.newProxy = function(cfgProxy, proxyData, config) {
    if (cfgProxy.type === 721) {
        return new DazProxy721XC( proxyData, config, this.chainId, cfgProxy.contractName);
    } else {
        return new DazProxy1155XC( proxyData, config, this.chainId, cfgProxy.contractName);
    }
}

DazAggregatorXC.prototype.getEnabledProxies = async function () {
    return this.load().then(agg => {
        return dazethutil.toLower(agg.getEnabledProxies);
    })
}

DazAggregatorXC.prototype.listUpgradeInventory = async function () {
    return this.load().then(agg => {
        return dazethutil.toLower(agg.listUpgradeInventory);
    })}

DazAggregatorXC.prototype.listEquippedUpgrades = async function (address, token) {
    return dazethutil.toLower([]);
}

DazAggregatorXC.prototype.load = async function () {
    if (!window.dazXC) {
        throw 'Not cross chain agg';
    }
    if (this.aggData !== false) {
        return this.aggData;
    }

    const xc = window.dazXC();
    const data = xc.data({
        who: dazethutil.me(),
        contract: this.address,
        now: (new Date).getTime(),
        chainID: this.chainId,
    })
    return fetch( "/nft-api/nfp/gen1/bridge/erc1155/aggregator", {
        method: 'POST',
        mode: 'cors',
        body: (new URLSearchParams(data)).toString(),
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        },
    }).then((response) => {
        if (!response.ok) {
            throw "could not load";
        }
        return response.json();
    }).then(json => {
        this.aggData = {
            getEnabledProxies: json.Proxies,
            listUpgradeInventory: json.Upgrades,
        }
        return this.aggData;
    });
}
